export default {"src":"/_next/static/media/check.4af2b5ea.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};